import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IListOrderCounterFetchParams,
  IOrderCounter,
  MN_ORDER_COUNTERS,
} from '@jobcost-monorepo/crud';

export default function OrderCountersPage() {
  return (
    <Grid<IOrderCounter, IListOrderCounterFetchParams>
      moduleName={MN_ORDER_COUNTERS}
      updateStore={false}
    ></Grid>
  );
}
